import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-546fb8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = {
  key: 0,
  class: "loading",
  "element-loading-background": "rgba(255, 255, 255, 0.6)"
}
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = {
  class: "active",
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQQFHOABOnFAAD7FQDMbMM452.png",
  alt: "PLASTICS MATERIAL"
}
const _hoisted_7 = {
  class: "no",
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQQFHOAbrsZAAAmQcMM_94427.png",
  alt: "PLASTICS MATERIAL"
}
const _hoisted_8 = {
  class: "active",
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQQFHOATb2pAAEEplprHgs576.png",
  alt: "STEELS MATERIAL"
}
const _hoisted_9 = {
  class: "no",
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQQFHOAHh7RAAAvwp2xK0g815.png",
  alt: "STEELS MATERIAL"
}
const _hoisted_10 = { class: "menu" }
const _hoisted_11 = { class: "menu-items" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "All Products", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  style: {"width":"100%","text-align":"center","margin":"30px 0"}
}
const _hoisted_16 = { class: "left-msg" }
const _hoisted_17 = { class: "msg" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item title" }, "Popular Products", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = ["alt"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  style: {"width":"100%","text-align":"center","margin-top":"30px"}
}
const _hoisted_24 = { class: "bts" }
const _hoisted_25 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BackTop = _resolveComponent("BackTop")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _createVNode(_component_Breadcrumb, {
      style: {"margin-bottom":"20px","padding-left":"10px"},
      "show-route-name": false,
      "breadcrumb-list": _ctx.breadcrumbList
    }, null, 8, ["breadcrumb-list"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "tab plastics",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab('PLASTICS MATERIAL')))
          }, [
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_vShow, _ctx.active === 'PLASTICS MATERIAL']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
              [_vShow, _ctx.active !== 'PLASTICS MATERIAL']
            ])
          ]),
          _createElementVNode("div", {
            class: "tab steels",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab('STEELS MATERIAL')))
          }, [
            _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
              [_vShow, _ctx.active === 'STEELS MATERIAL']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
              [_vShow, _ctx.active !== 'STEELS MATERIAL']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (name) => {
              return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ background: _ctx.menuName === name ? '#EDEFF3' : '' }),
                class: "menu-item",
                onClick: ($event: any) => (_ctx.clickMenu(name)),
                key: name
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(["name", _ctx.menuName === name ? 'menu-active' : ''])
                }, _toDisplayString(name), 3),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowRight)
                  ]),
                  _: 1
                })
              ], 12, _hoisted_14))
            }), 128)),
            (!_ctx.menuList || _ctx.menuList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "NO DATA... "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: _ctx.aHref(item)
                }, [
                  _withDirectives(_createElementVNode("img", {
                    alt: item.titlt
                  }, null, 8, _hoisted_21), [
                    [_directive_lazy, _ctx.splitImg(item.allImg)]
                  ])
                ], 8, _hoisted_20),
                _createElementVNode("div", {
                  class: "text",
                  onClick: ($event: any) => (_ctx.toDetail(item))
                }, _toDisplayString(item.title), 9, _hoisted_22)
              ]))
            }), 128)),
            (!_ctx.recommendList || _ctx.recommendList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, " NO DATA....."))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: "bt",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pre && _ctx.pre(...args)))
              }, [
                _createVNode(_component_el_icon, { size: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowUp)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: "bt",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, [
                _createVNode(_component_el_icon, { size: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDown)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(_component_BackTop),
    _createVNode(_component_ChatBox),
    _createVNode(_component_Footer)
  ]))
}